function path(root, sublink) {
  return `${root}${sublink}`;
}

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

const BASE_PATH = '/';
const BASE_ADMIN_PATH = '/admin';
const ROOTS_DASHBOARD = '/admin/dashboard';
const ROOTS_USER_DASHBOARD = '/dashboard';

// admin paths

export const PATH_ADMIN_AUTH = {
  root: BASE_ADMIN_PATH,
  login: path(BASE_ADMIN_PATH, '/login'),
  verify: path(BASE_ADMIN_PATH, '/verify'),
  resetPassword: path(BASE_ADMIN_PATH, '/reset-password'),
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/home'),
    userApp: path(ROOTS_DASHBOARD, '/userHome'),
  },

  users: {
    root: path(ROOTS_DASHBOARD, '/users/list'),
    list: path(ROOTS_DASHBOARD, '/users/list'),
  },
  instructions: {
    root: path(ROOTS_DASHBOARD, '/instructions'),
  },

  funds: {
    root: path(ROOTS_DASHBOARD, '/funds/:userId/details'),
  },

  user: {
    account: path(ROOTS_DASHBOARD, '/user/account'),
  },
};

// user paths

export const PATH_AUTH = {
  root: BASE_PATH,
  login: path(BASE_PATH, 'login'),
};

export const PATH_USER_DASHBOARD = {
  root: ROOTS_USER_DASHBOARD,
  general: {
    app: path(ROOTS_USER_DASHBOARD, '/home'),
    account: path(ROOTS_USER_DASHBOARD, '/profile'),
    fund: path(ROOTS_USER_DASHBOARD, '/fund'),
    tradingSummary: path(ROOTS_USER_DASHBOARD, '/trading-summary'),
    transactions: path(ROOTS_USER_DASHBOARD, '/transactions'),
  },
};
